import { useContext } from 'react';

import type { WebThemeContextProps } from './types';
import { WebThemeContext } from './WebThemeContext';

export const useWebThemeContext = () => useContext(WebThemeContext) as WebThemeContextProps;
